class SamplesDrawerTrigger extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.querySelector('samples-drawer');
    this.trigger = this.querySelector('button');
    this.overlay = document.querySelector('[data-samples-overlay]');
    
    // Add event listener to the button
    this.trigger.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    // Get the drawer element, find the parent div and toggle the 'active' class
    if (this.drawer) {
      this.drawer.toggleOpen(e);
    }
  }
}

if (!customElements.get('samples-drawer-trigger')) {
  customElements.define('samples-drawer-trigger', SamplesDrawerTrigger);
}
